import React from 'react'
import { Grid, GridColumn, GridRow } from 'semantic-ui-react'
import AddressFields from '../common/fieldgroups/AddressFields'
import NameFields from '../common/fieldgroups/NameFields'
import RegisteredFormField from '../../common/RegisteredFormField'
import PersonalFields from '../common/fieldgroups/PersonalFields'
import useScrollToTop from '../../../hooks/useScrollToTop'

export const EMAIL_TOOLTIP = 'The \'Employee Email\' that you provide below will be used for the confirmation of receipt of the form, ' +
  'which includes information on what to expect next.'

export default function Employee () {
  return useScrollToTop(<>
    <Grid container stackable divided='vertically'>
      <GridRow>
        <GridColumn width={16}>
          <h3>Contact Information</h3>
        </GridColumn>
      </GridRow>
      <GridRow>
        <NameFields rootPath='segments.employee.fields' />
        <AddressFields
          rootPath='segments.employee.fields'
          withSecondaryAddressLine={true}
        />
        <GridColumn computer={6} tablet={8} mobile={16}>
          <RegisteredFormField
            id='employeeEmail'
            path='segments.employee.fields.email'
            label='Employee Email'
            hoverDetail={EMAIL_TOOLTIP}
          />
        </GridColumn>
        <GridColumn computer={6} tablet={8} mobile={16}>
          <RegisteredFormField
            id='employeeTelephone'
            path='segments.employee.fields.telephone'
            label='Telephone'
          />
        </GridColumn>
      </GridRow>
    </Grid>
    <Grid container stackable divided='vertically'>
      <GridRow>
        <GridColumn width={16}>
          <h3 className='modal-title'>Employment Information</h3>
        </GridColumn>
      </GridRow>
      <GridRow>
        <GridColumn width={10}>
          <RegisteredFormField
            id='jobTitle'
            path='segments.employee.fields.employment.jobTitle'
            label='Job Title/Description'
          />
        </GridColumn>
        <GridColumn width={8}>
          <RegisteredFormField
            id='employmentDate'
            path='segments.employee.fields.employment.fullTimeEmploymentDate'
            label='Current Full-Time Employment Date'
          />
        </GridColumn>
        <GridColumn width={8}>
          <RegisteredFormField
            id='avgHoursWorked'
            path='segments.employee.fields.employment.avgHoursWorked'
            label='Average Hours Worked/Week (optional)'
          />
        </GridColumn>
      </GridRow>
    </Grid>
    <Grid container stackable divided='vertically'>
      <GridRow>
        <GridColumn width={16}>
          <h3 className='modal-title'>Personal Information</h3>
        </GridColumn>
      </GridRow>
      <GridRow>
        <PersonalFields
          rootPath='segments.employee.fields.personal'
          withSalary={true}
        />
      </GridRow>
      <GridRow>
        <GridColumn width={16}>
          <RegisteredFormField
            id='nameUsed'
            path='segments.employee.fields.otherNames'
            label={<label htmlFor='nameUsed'>
              Name(s) used for medical records for any proposed insured<br />
              <i>(If different than the name(s) provided on this form):</i>
            </label>}
          />
        </GridColumn>
      </GridRow>
    </Grid>
  </>)
}
